import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DxTemplateHost, IterableDifferHelper, NestedOptionHost, WatcherHelper } from 'devextreme-angular';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { DOLayoutModule } from './do-layout/do-layout.module';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LocalDateTimePipe } from './shared/pipes/local-date-time.pipe';
import { TimeAgoPipe } from './shared/pipes/time-as-ago.pipe';
import { LoaderInterceptor } from './shared/services/loader.interceptor';


@NgModule({
    declarations: [
        AppComponent,
        LoaderComponent,
        TimeAgoPipe
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        CoreModule,
        DOLayoutModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LocalDateTimePipe,
        ToastrModule.forRoot({
            preventDuplicates: true,
            autoDismiss: true
        }),
        MatSnackBarModule,
        MatProgressBarModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,

            registrationStrategy: 'registerWhenStable:30000'
        }),
        MatIconModule], 
        providers: [
            // Overlays (dialogs, snackbars, menus) attach to <body>, which is
            // NOT rendered while another element is fullscreen — the Flow
            // editor's full-screen mode would hide every dialog opened from it.
            // The CDK's fullscreen-aware container re-homes overlays into the
            // fullscreen element while one is active; identical behaviour
            // otherwise.
            { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
            { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
            { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
            { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000, horizontalPosition: "center", verticalPosition: 'bottom' } },
            DxTemplateHost,
            WatcherHelper,
            IterableDifferHelper,
            NestedOptionHost,
            LocalDateTimePipe,
            TimeAgoPipe,
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
